import React from "react";
import {
  FaUser,
  FaCamera,
  FaUsers,
  FaMapMarkerAlt,
  FaUserTie,
  FaShieldAlt,
  FaEdit,
  FaDownload,
  FaInfoCircle,
} from "react-icons/fa";

import "./MembershipDetails.css";

function MembershipDetails() {
  const member = {
    name: "Ramesh Babu",
    memberId: "APNBM240520001",
    dob: "12/05/1990",
    gender: "Male",
    email: "rameshbabu@email.com",
    mobile: "+91 91234 56789",
    maritalStatus: "Married",
    joiningDate: "20 May 2024",
    membershipType: "Annual Membership",
    validTill: "19 May 2025",
    status: "Active",

    currentAddress: (
      <>
        D.No: 12-3-45,
        <br />
        Guntur, Andhra Pradesh - 522001
        <br />
        India
      </>
    ),

    permanentAddress: (
      <>
        D.No: 12-3-45,
        <br />
        Guntur, Andhra Pradesh - 522001
        <br />
        India
      </>
    ),
  };

  const familyMembers = [
    {
      name: "Suresh Babu",
      relation: "Father",
      dob: "01/01/1960",
      gender: "Male",
    },
    {
      name: "Lakshmi Devi",
      relation: "Mother",
      dob: "15/03/1965",
      gender: "Female",
    },
    {
      name: "Swapna Babu",
      relation: "Wife",
      dob: "22/07/1992",
      gender: "Female",
    },
    {
      name: "Chaitanya",
      relation: "Son",
      dob: "10/06/2018",
      gender: "Male",
    },
    {
      name: "Varshini",
      relation: "Daughter",
      dob: "05/09/2021",
      gender: "Female",
    },
  ];

  return (
    <main className="membership-page">

      {/* =====================================================
          PAGE HEADER
      ===================================================== */}

      <div className="membership-page-header">

        <div>
          <h1>Membership Details</h1>

          <div className="membership-breadcrumb">
            <span>Home</span>
            <span className="breadcrumb-arrow">›</span>
            <span>Membership Details</span>
          </div>
        </div>

        <button
          type="button"
          className="membership-download-btn"
        >
          <FaDownload />
          <span>Download Membership Details</span>
        </button>

      </div>


      {/* =====================================================
          TOP MAIN CARD
      ===================================================== */}

      <section className="membership-main-card">

        {/* ===================================================
            PRIMARY MEMBER
        =================================================== */}

        <div className="primary-member">

          <div className="membership-card-title">

            <div className="membership-title-icon blue-icon">
              <FaUser />
            </div>

            <h2>Primary Member Information</h2>

          </div>


          <div className="primary-member-body">

            {/* PHOTO */}

            <div className="primary-photo-area">

              <div className="member-photo">

                <div className="member-photo-letter">
                  R
                </div>

              </div>

              <button
                type="button"
                className="update-photo-btn"
              >
                <FaCamera />
                <span>Update Photo</span>
              </button>

            </div>


            {/* MEMBER INFORMATION */}

            <div className="primary-information">

              <DetailRow
                label="Full Name"
                value={member.name}
              />

              <DetailRow
                label="Member ID"
                value={member.memberId}
              />

              <DetailRow
                label="Date of Birth"
                value={member.dob}
              />

              <DetailRow
                label="Gender"
                value={member.gender}
              />

              <DetailRow
                label="Email"
                value={member.email}
              />

              <DetailRow
                label="Mobile Number"
                value={member.mobile}
              />

              <DetailRow
                label="Marital Status"
                value={member.maritalStatus}
              />

              <DetailRow
                label="Date of Joining"
                value={member.joiningDate}
              />

              <DetailRow
                label="Membership Type"
                value={member.membershipType}
              />

              <DetailRow
                label="Membership Valid Till"
                value={member.validTill}
              />

              <DetailRow
                label="Membership Status"
                value={
                  <span className="active-status">
                    {member.status}
                  </span>
                }
              />

            </div>

          </div>

        </div>


        {/* ===================================================
            FAMILY MEMBERS
        =================================================== */}

        <div className="family-members">

          <div className="membership-card-title">

            <div className="membership-title-icon purple-icon">
              <FaUsers />
            </div>

            <h2>Family Members</h2>

          </div>


          <div className="family-table-container">

            <table className="family-table">

              <thead>
                <tr>
                  <th>Name</th>
                  <th>Relation</th>
                  <th>Date of Birth</th>
                  <th>Gender</th>
                </tr>
              </thead>

              <tbody>

                {familyMembers.map((person, index) => (
                  <tr key={index}>

                    <td>{person.name}</td>

                    <td>{person.relation}</td>

                    <td>{person.dob}</td>

                    <td>{person.gender}</td>

                  </tr>
                ))}

              </tbody>

            </table>

          </div>


          <button
            type="button"
            className="family-update-btn"
          >
            <FaEdit />
            <span>Update Family Details</span>
          </button>

        </div>

      </section>


      {/* =====================================================
          LOWER THREE CARDS
      ===================================================== */}

      <section className="membership-lower-section">


        {/* ===================================================
            ADDRESS
        =================================================== */}

        <div className="membership-info-card">

          <div className="membership-card-title">

            <div className="membership-title-icon green-icon">
              <FaMapMarkerAlt />
            </div>

            <h2>Address Details</h2>

          </div>


          <div className="address-content">

            <div className="address-item">

              <h3>Current Address</h3>

              <p>
                {member.currentAddress}
              </p>

            </div>


            <div className="address-divider"></div>


            <div className="address-item">

              <h3>Permanent Address</h3>

              <p>
                {member.permanentAddress}
              </p>

            </div>


            <button
              type="button"
              className="address-update-btn"
            >
              <FaEdit />
              <span>Update Address</span>
            </button>

          </div>

        </div>


        {/* ===================================================
            NOMINEE
        =================================================== */}

        <div className="membership-info-card">

          <div className="membership-card-title">

            <div className="membership-title-icon orange-icon">
              <FaUserTie />
            </div>

            <h2>Nominee Details</h2>

          </div>


          <div className="nominee-details">

            <DetailRow
              label="Nominee Name"
              value="Lakshmi Devi"
            />

            <DetailRow
              label="Relationship"
              value="Wife"
            />

            <DetailRow
              label="Date of Birth"
              value="10/02/1992"
            />

            <DetailRow
              label="Mobile Number"
              value="+91 91234 56780"
            />

            <DetailRow
              label="Address"
              value={
                <>
                  D.No: 12-3-45,
                  <br />
                  Guntur, Andhra Pradesh - 522001
                </>
              }
            />

          </div>


          <button
            type="button"
            className="nominee-update-btn"
          >
            <FaEdit />
            <span>Update Nominee Details</span>
          </button>

        </div>


        {/* ===================================================
            MEMBERSHIP INFORMATION
        =================================================== */}

        <div className="membership-info-card">

          <div className="membership-card-title">

            <div className="membership-title-icon shield-icon">
              <FaShieldAlt />
            </div>

            <h2>Membership Information</h2>

          </div>


          <div className="membership-payment-details">

            <DetailRow
              label="Membership ID"
              value="APNBM240520001"
            />

            <DetailRow
              label="Membership Type"
              value="Annual Membership"
            />

            <DetailRow
              label="Membership Fee"
              value="₹ 1199.00"
            />

            <DetailRow
              label="Convenience Fee"
              value="₹ 0.00"
            />

            <DetailRow
              label="Total Amount Paid"
              value={
                <span className="paid-amount">
                  ₹ 1199.00
                </span>
              }
            />

            <DetailRow
              label="Payment Date"
              value="20 May 2024"
            />

            <DetailRow
              label="Payment Method"
              value="UPI (Razorpay)"
            />

            <DetailRow
              label="Transaction ID"
              value="pay_N8xY2k3L4m5P8Q"
            />

          </div>

        </div>

      </section>


      {/* =====================================================
          INFORMATION MESSAGE
      ===================================================== */}

      <div className="membership-information">

        <FaInfoCircle />

        <span>
          If you find any incorrect information, please update it.
          For further assistance, contact our support team.
        </span>

      </div>

    </main>
  );
}


/* ==========================================================
   DETAIL ROW
========================================================== */

function DetailRow({ label, value }) {
  return (
    <div className="detail-row">

      <span className="detail-label">
        {label}
      </span>

      <span className="detail-colon">
        :
      </span>

      <span className="detail-value">
        {value}
      </span>

    </div>
  );
}


export default MembershipDetails;